<script lang="ts">
	import { page } from '$app/state';

	const { children } = $props();

	const links = [
		{ href: '/legal', label: 'Overview' },
		{ href: '/legal/terms', label: 'Terms of Service' },
		{ href: '/legal/privacy', label: 'Privacy Policy' },
		{ href: '/legal/dpa', label: 'Data Processing Addendum' },
		{ href: '/legal/subprocessors', label: 'Subprocessors' }
	];
</script>

<div class="mx-auto max-w-[60rem] px-10 pt-24 pb-24 sm:px-20 sm:pt-32 lg:px-28">
	<nav aria-label="Legal" class="mb-10 flex flex-wrap gap-x-6 gap-y-2 text-sm">
		{#each links as link (link.href)}
			{@const active = page.url.pathname === link.href}
			<a
				href={link.href}
				class="transition-colors {active
					? 'text-primary font-medium'
					: 'text-soft-gray hover:text-primary'}"
				aria-current={active ? 'page' : undefined}
			>
				{link.label}
			</a>
		{/each}
	</nav>

	{@render children?.()}
</div>
